import client from './client';
import qs from 'qs';

/**
 * 우선노출 리스트
 */
export const priEprsList = (param) => client.get(`/api/adver/priEprs`, param);

/**
 * 우선노출 광고주 캠페인검색
 */
export const priEprsCampaignList = (param) =>
  client.get(`/api/adver/priEprs/campaign`, param);

/**
 * 우선노출 캠페인 수정
 */
export const setPrieprsCampaign = (param) =>
  client.post(`/api/adver/priEprs/set`, qs.stringify(param));

/**
 * OS차단관리 - 캠페인차단 리스트
 */
export const osBlockCampaignList = (param) =>
  client.get(`/api/adver/osBlock`, param);

/**
 * OS차단관리 - 광고주차단 리스트
 */
export const osBlockAdverList = (param) =>
  client.get(`/api/adver/osBlock/adver`, param);

/**
 * 우선노출 광고주
 */
export const osBlockSet = (param) =>
  client.post(`/api/adver/osBlock/set`, qs.stringify(param));
